import dayjs, { Dayjs } from 'dayjs'
import useGetRealTime from '../useGetRealTime/useGetRealTime'
import { useEffect, useState } from 'react'

interface useCalTotalHourProps {
    defaultTime?: string
    isCounting?: boolean
}

const useCalTotalHour = ({ defaultTime, isCounting }: useCalTotalHourProps) => {
    const [currentDate, stopTime, startTime] = useGetRealTime(false)
    const [realTime, setRealTime] = useState<Dayjs>()

    useEffect(() => {
        setRealTime(dayjs(defaultTime, 'HH:mm:ss'))
    }, [defaultTime, setRealTime])

    useEffect(() => {
        if (isCounting) {
            startTime()
        } else {
            stopTime()
        }
    }, [startTime, stopTime, isCounting])

    useEffect(() => {
        if (currentDate) {
            setRealTime((pre) => {
                return pre ? pre.add(1, 's') : pre
            })
        }
    }, [setRealTime, currentDate, isCounting])

    return [realTime] as const
}

export default useCalTotalHour
